import { FC } from 'react';
import DateBox, { IDateBoxOptions } from 'devextreme-react/date-box';
import styles from './DX.module.scss';

export const DxDateBox: FC<IDateBoxOptions> = (props) => {

    return <DateBox className={styles.dxDatebox} {...props} openOnFieldClick={true}/>;
};
